module.exports = __webpack_public_path__ + "static/media/shareLockGuide6.2ccff44d.png";